export default (theme) => ({
    metadata: {
        alignItems: 'center',
        display: 'flex',
        gap: 8,
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
});
